import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Button from "@mui/material/Button";
import LogoutIcon from "@mui/icons-material/Logout";
import { useTheme } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import { useNavigate } from "react-router-dom";

const LeftBar = ({
  drawerOpen,
  handleDrawerToggle,
  handleChange,
  value,
  isSmallScreen,
}) => {
  const theme = useTheme();

  const drawerStyles = {
    backgroundColor:
      "linear-gradient(44.43deg, #1c5768 -20.27%, #164E47 105%) !important",
    color: "white !important",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    // boxShadow:
    //     "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    flex: "1 0 auto",
    zIndex: 1200,
    position: "fixed",
    top: 0,
    outline: 0,
    left: 0,
    [theme.breakpoints.down("md")]: {
      background:
        "linear-gradient(44.43deg, #1c5768 -20.27%, #164E47 105%) !important",
      color: "white !important",
    },
  };

  const tabsStyles = {
    borderRight: "none",
    borderBottom: "none",
    borderColor: "divider",
    flex: "0 0 auto",
    color: "white !important",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    // boxShadow:
    //   "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px",
    "& .MuiTab-root": {
      color: "white",
      //   textShadow: "2px 2px 0px #131212",
      margin: "10px", // Add margin to the tabs
      borderRadius: "6px", // Add border radius to the tabs
      "&.Mui-selected": {
        color: "white",
        backgroundColor: "rgba(255, 255, 255, 0.2) !important",
      },
    },
    [theme.breakpoints.down("md")]: {
      background: "linear-gradient(44.43deg, #1c5768 -20.27%, #164E47 105%)",
      "& .MuiTab-root": {
        color: "white",
        // textShadow: "2px 2px 0px #131212",
        margin: "10px", // Add margin to the tabs
        borderRadius: "6px", // Add border radius to the tabs
        "&.Mui-selected": {
          color: "white",
          backgroundColor: "rgba(255, 255, 255, 0.2) !important",
        },
      },
    },
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    // Your logout logic here (e.g., clearing user data, calling an API endpoint)
    navigate("/logout");
  };

  return (
    <div
      className="deshbord-leftSide"
      style={{ display: isSmallScreen ? "none" : "block" }}
    >
      {isSmallScreen ? (
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={handleDrawerToggle}
          sx={{
            "& .MuiDrawer-paper": {
              width: "240px",
              ...drawerStyles,
            },
          }}
        >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Responsive tabs example"
            sx={tabsStyles}
          >
            <Tab label="Indian Panorama" />
            <Tab label="Best Web Series (OTT) Award" />
            <Tab label="Creative Minds Of Tomorrow" />
            {/* <Tab label="CinemAI Hackathon" /> */}
          </Tabs>
          <div
            className="log_out_btn"
            style={{ textAlign: "center", padding: "10px" }}
          >
            <Button
              variant="outlined"
              startIcon={<LogoutIcon />}
              style={{
                color: "white",
                border: "none",
                marginRight: "2rem",
              }}
              href={process.env.REACT_APP_BASE_PREFIX + "/logout"}
            >
              Logout
            </Button>
          </div>
        </Drawer>
      ) : (
        <>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Responsive tabs example"
            sx={tabsStyles}
          >
            <Tab label="Indian Panorama" />
            <Tab label="Best Web Series (OTT) Award" />
            <Tab label="Creative Minds Of Tomorrow" />
            {/* <Tab label="CinemAI Hackathon" /> */}
          </Tabs>

          <div
            className="log_out_btn"
            style={{ textAlign: "center", padding: "10px" }}
          >
            <Button
              variant="outlined"
              startIcon={<LogoutIcon />}
              style={{
                color: "white",
                border: "none",
                marginRight: "2rem",
              }}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default LeftBar;
